export const downloadOurApp = {
  downloadOurApp: "Download our app on iOS and Android",
  availableOn:
    "Available on phones and tables with an optimized reading experience. Supports Single, Double, Panel-to-Panel, Vertical Scroll layouts, and offline reading on the go.",
  getOnApple: "Get on the App Store",
  getOnGoogle: "Get on Google Play",
};
